import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API_BASE_URL from "../config/api";
import "./Shop.css";

function Shop() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  /* ====
     IMAGE URL
  ==== */

  const getImageUrl = (image) => {
    if (!image) return "";

    if (image.startsWith("http")) {
      return image;
    }

    return `${API_BASE_URL}/${String(image).replace(/^\/+/, "")}`;
  };

  /* ====
     FETCH PRODUCTS
  ==== */

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await fetch(
          `${API_BASE_URL}/api/products`
        );

        const data = await response.json();

        if (data.success) {
          setProducts(data.products || []);
        }
      } catch (error) {
        console.error("Error fetching products:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  /* ====
     LOADING
  ==== */

  if (loading) {
    return (
      <div className="tv-products-loading">
        Loading watches...
      </div>
    );
  }

  return (
    <section className="tv-men-products">

      {/* 
          SHOP HERO
       */}

      <div
        className="tv-shop-hero"
        style={{
          backgroundImage: `
            linear-gradient(
              rgba(18, 36, 25, 0.48),
              rgba(18, 36, 25, 0.48)
            ),
            url("/watches.webp")
          `,
        }}
      >
        <div className="tv-shop-hero-content">

          <span className="tv-shop-hero-eyebrow">
            TIME VALLEY WATCHES
          </span>

          <div className="tv-shop-hero-line"></div>

          <h1>
            Discover Your
            <br />
            <span>Perfect Timepiece.</span>
          </h1>

          <p>
            Explore our curated collection of premium watches,
            crafted for those who appreciate timeless style,
            precision and character.
          </p>

          <button
            className="tv-shop-hero-button"
            onClick={() =>
              document
                .getElementById("tv-shop-collection")
                ?.scrollIntoView({
                  behavior: "smooth",
                })
            }
          >
            Explore Collection
            <span>→</span>
          </button>
        </div>

        <div className="tv-shop-hero-mark">
          THE COLLECTION
        </div>
      </div>

      {/* 
          PRODUCTS
       */}

      <div
        className="tv-men-products-container"
        id="tv-shop-collection"
      >

        <div className="tv-men-products-header">
          <span>TIME VALLEY</span>

          <h1>Men's Collection</h1>

          <p>
            Discover our latest collection of premium watches.
          </p>
        </div>

        {products.length === 0 ? (
          <div className="tv-no-products">
            <h3>No watches available</h3>
            <p>
              New watches will appear here soon.
            </p>
          </div>
        ) : (
          <div className="tv-men-products-grid">

            {products.map((product, index) => {
              const imageUrl = getImageUrl(product.image1);

              return (
                <div
                  className="tv-men-product-card"
                  key={product.id}
                  onClick={() =>
                    navigate(`/product/${product.id}`)
                  }
                >

                  {/* =================================================
                      PRODUCT IMAGE
                  ================================================= */}

                  <div className="tv-men-product-image">

                    <img
                      src={imageUrl}
                      alt={product.name || "Time Valley Watch"}
                      width="600"
                      height="600"

                      /*
                        First 4 products load immediately.
                        Remaining products lazy-load.
                      */
                      loading={index < 4 ? "eager" : "lazy"}

                      /*
                        First 4 products get higher browser
                        download priority.
                      */
                      fetchPriority={
                        index < 4 ? "high" : "auto"
                      }

                      /*
                        Allows browser to decode image
                        without blocking the page.
                      */
                      decoding="async"

                      /*
                        If image fails, hide broken-image icon.
                      */
                      onError={(e) => {
                        e.currentTarget.style.visibility =
                          "hidden";
                      }}
                    />

                    {product.tag && (
                      <span className="tv-men-product-tag">
                        {product.tag}
                      </span>
                    )}

                  </div>

                  {/* =================================================
                      PRODUCT INFO
                  ================================================= */}

                  <div className="tv-men-product-info">

                    <h3>{product.name}</h3>

                    <p>
                      {product.description}
                    </p>

                  <div className="tv-men-product-bottom">
  <div className="tv-men-product-pricing">
    {product.top_price &&
      Number(product.top_price) > Number(product.price) && (
        <div className="tv-men-product-original-row">
          <span className="tv-men-product-original-price">
            Rs: {Number(product.top_price).toLocaleString()}
          </span>

          <span className="tv-men-product-discount">
            {Math.round(
              ((Number(product.top_price) -
                Number(product.price)) /
                Number(product.top_price)) *
                100
            )}
            % OFF
          </span>
        </div>
      )}

    <strong className="tv-men-product-current-price">
      Rs: {Number(product.price || 0).toLocaleString()}
    </strong>
  </div>

  <button
    onClick={(e) => {
      e.stopPropagation();
      navigate(`/product/${product.id}`);
    }}
  >
    View Details
  </button>
</div>

                  </div>

                </div>
              );
            })}

          </div>
        )}

      </div>

    </section>
  );
}

export default Shop;